<template>
  <popup
    ref="popup"
    title="检查更新"
    :width="500"
    openType="modal"
    @on-ok="onOk"
    :closable="false"
    footer-hide
    @on-visible-change="onVisibleChange"
  >
    <div class="version-text" v-if="info.version">
      <span>最新版本：{{ info.version }}</span>
      <span style="margin-left: 20px">当前版本：{{ pkg.version }}</span>
    </div>
    <Button v-if="type===1" style="display: block;margin: auto" type="primary" loading>获取最新版本中请稍等...</Button>
    <div v-if="type===2">
      <Progress :percent="percent" :stroke-width="20" status="active" text-inside/>
      <div class="install-tip">正在更新安装包，请稍等...</div>
    </div>
    <Button type="primary" style="display:block;margin: 0 auto 16px auto" @click="updateNow" v-if="type===3">
      更新完成，立即安装
    </Button>
    <div style="background: #eeeeee;padding: 11px" v-if="logList&&logList.length">
      <p style="font-size: 16px;font-weight: bold">最近更新：</p>
      <div class="list" v-for="(item,index) in logList" :key="index">{{ index + 1 }},{{ item }}</div>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup";
import {ipcRenderer} from "electron";
import changelog from "../../../../changelog";

export default {
  components: {
    popup,
  },
  data() {
    return {
      percent: 0,
      type: 1,
      info: {},
      pkg: {},
      logList: [],
    };
  },
  methods: {
    open(res, type) {
      // console.log(res, 88, type);
      this.type = type;
      this.pkg = require('../../../../package.json');
      this.info = res;
      if ([1].includes(type)) {
        ipcRenderer.send('downloadUpdate');
      }
      this.percent = Number((res.percent || 0).toFixed(2));
      this.$refs.popup.open();
      if (this.type === 3) {//简单处理日志，(有问题显示)显示的是最新版本上一版信息;
        let arr = Object.keys(changelog);
        this.logList = changelog[arr[arr.length - 1]] || [];
      }
    },
    updateNow() {
      ipcRenderer.send('updateNow');
    },
    onOk() {

    },
    onVisibleChange(e) {

    },
  },
};
</script>

<style scoped lang="less">
.install-tip {
  margin-top: 8px;
  font-size: 14px;
  color: #86909C;
  text-align: center;
}

.version-text {
  color: #1D2129;
  font-size: 16px;
  text-align: center;
  margin: 16px 0;
}

.list {
  color: #86909C;
  line-height: 26px;
}
</style>
